import React from 'react'
import { Typography } from '@mui/material'

const PageTitle = ( {pageTitle = "Title"} ) => {
  return (
    <Typography variant="h6"  align="left"  gutterBottom = "true">
         {pageTitle}
    </Typography>
  )
}

export default PageTitle